module.exports = __webpack_public_path__ + "photo_spot_international_header_logo.png?89b711fb4153fa8ff0f7e86b5a42363b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo_spot_international_header_logo.png
// module id = 148
// module chunks = 0